import { createLogger } from "./logger";
const logger = createLogger("asset-preload");
function preloadAssets(assets) {
    const fragment = document.createDocumentFragment();
    assets.forEach((asset) => {
        logger.logInfo(`Add preload tag for ${asset.href} of kind ${asset.kind}`);
        const preload = document.createElement("link");
        preload.rel = "preload";
        preload.href = asset.href;
        preload.as = asset.kind;
        if (asset.type) {
            preload.type = asset.type;
        }
        if (asset.crossOrigin) {
            preload.crossOrigin = asset.crossOrigin;
        }
        fragment.appendChild(preload);
        return undefined;
    });
    document.head.appendChild(fragment);
}
// eslint-disable-next-line import/prefer-default-export
export { preloadAssets };
//# sourceMappingURL=preload.js.map